import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yntobool'
})
export class YntoboolPipe implements PipeTransform {

  transform(value: string): boolean{
    //console.log(value);
    if(value == 'Y' || value == 'y'){
      return true;
    }else if(value == 'N' || value == 'n'){
      return false;
    }
  }

}
